/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Documents_RenameInputs */

const cs_documents_rename = /** @type {(inputs: Documents_RenameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přejmenovat`)
};

const en_documents_rename = /** @type {(inputs: Documents_RenameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rename`)
};

/**
* | output |
* | --- |
* | "Rename" |
*
* @param {Documents_RenameInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_rename = /** @type {((inputs?: Documents_RenameInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_RenameInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_documents_rename(inputs)
	return cs_documents_rename(inputs)
});